<template>
  <div class="contact-location-switcher">
    <h4 class="contact-location-switcher__title">
      {{ $t('footer.contact.title') }}
    </h4>
    <ul class="contact-location-switcher__list">
      <li
        class="contact-location-switcher__list-item"
        v-for="contactFooterNavigationTreeItem of contactFooterNavigationTree"
        :key="contactFooterNavigationTreeItem.id"
      >
        <DKButton
          :inverted="true"
          @click="$emit('clickContactLink', contactFooterNavigationTreeItem)"
        >
          {{ contactFooterNavigationTreeItem.label }}
        </DKButton>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import { NavigationTree } from '@/store/navigation/models/NavigationTree';
import { DKButton } from '@dormakaba/dormakaba-components';
import GenericAccordion from '@/components/accordions/GenericAccordion.vue';
import ContactFooterAccordionTab from '@/components/accordions/ContactFooterAccordionTab.vue';
import { useMq } from 'vue3-mq';

@Component({
  components: {
    DKButton,
    GenericAccordion,
    ContactFooterAccordionTab,
  },
  emits: ['clickContactLink'],
})
export default class ContactLocationSwitcher extends Vue {
  @Prop() contactFooterNavigationTree!: NavigationTree[];

  openTab = false;

  get isOpen(): boolean {
    return this.openTab || ['xl'].includes(this.$mq.current);
  }

  created() {
    this.$mq = useMq();
  }

  onClickTab() {
    this.openTab = !this.openTab;
  }
}
</script>

<style scoped lang="postcss">
.contact-location-switcher {
  @apply flex flex-col items-center justify-center;
  @apply h-full w-full;
  @apply px-32 pb-5 pt-9;
}

.contact-location-switcher__title {
  @apply text-white;
  @apply mb-4;
}

.contact-location-switcher__list {
  @apply flex flex-wrap justify-center;
  @apply pl-0;
}

.contact-location-switcher__list-item {
  @apply my-2 mr-3;
}
</style>
